import { createActions } from 'redux-actions';

import { PaymentTransaction } from '@models/PaymentTransaction';
import { Billing } from '@models/Billing';
import { CreatePaymentTransactionParams } from '@apis/PaymentTransactionApi';
import { GetBillingParams } from '@apis/BillingApi';
import { HealthQuote } from '@models/HealthQuote';
import { GetHealthQuoteParams } from '@apis/HealthQuoteApi';

export type State = {
  healthQuote?: HealthQuote | null;
  billing?: Billing | null;
  paymentTransaction?: PaymentTransaction | null;
}

export type HealthQuoteFetchPayload = GetHealthQuoteParams;
export type BillingFetchPayload = GetBillingParams;
export type PaymentTransactionCreatePayload = CreatePaymentTransactionParams;
export type StateUpdatePayload = Partial<State>;

export const {
  healthQuoteFetch,
  billingFetch,
  paymentTransactionCreate,
  stateUpdate,
} = createActions(
  'HEALTH_QUOTE_FETCH',
  'BILLING_FETCH',
  'PAYMENT_TRANSACTION_CREATE',
  'STATE_UPDATE',
  {
    prefix: 'HEALTH_QUOTE_PAYMENT_PAGE',
  },
);
